/* eslint-disable local-rules/page-boundary-imports */
import type { ProviderDefaults } from '@carvana/experiment/SharedTypes';
import { commonEnvironment } from '~/constants/environment';
import type { CommonEnvironment } from '~/contracts/common';
import * as dealership from '../dealership/experiments';
import * as flp from '../flp/experiments';
import * as home from '../home/experiments';
import * as sem from '../sem/experiments';
import * as srp from '../srp/experiments';
import * as vdp from '../vdp/experiments';

type CustomProviderDefaults = ProviderDefaults & {
  environment: CommonEnvironment;
};

export const settings: CustomProviderDefaults = {
  cacheMinutes: 30,
  cookieRefreshWindowMinutes: 15,
  environment: commonEnvironment
};

export const clientSideBrowserCookieIdExperiments = {
  ...dealership.clientSideBrowserCookieIdExperiments,
  ...flp.clientSideBrowserCookieIdExperiments,
  ...home.clientSideBrowserCookieIdExperiments,
  ...sem.clientSideBrowserCookieIdExperiments,
  ...srp.clientSideBrowserCookieIdExperiments,
  ...vdp.clientSideBrowserCookieIdExperiments
};

export const serverSideBrowserCookieIdExperiments = {
  ...dealership.serverSideBrowserCookieIdExperiments,
  ...flp.serverSideBrowserCookieIdExperiments,
  ...home.serverSideBrowserCookieIdExperiments,
  ...sem.serverSideBrowserCookieIdExperiments,
  ...srp.serverSideBrowserCookieIdExperiments,
  ...vdp.serverSideBrowserCookieIdExperiments
};

export const clientSideUserIdExperiments = {
  ...dealership.clientSideUserIdExperiments,
  ...flp.clientSideUserIdExperiments,
  ...home.clientSideUserIdExperiments,
  ...sem.clientSideUserIdExperiments,
  ...srp.clientSideUserIdExperiments,
  ...vdp.clientSideUserIdExperiments
};

// NOTE: Not currently wired up in the getExperiments middleware
export const serverSideUserIdExperiments = {
  ...dealership.serverSideUserIdExperiments,
  ...flp.serverSideUserIdExperiments,
  ...home.serverSideUserIdExperiments,
  ...sem.serverSideUserIdExperiments,
  ...srp.serverSideUserIdExperiments,
  ...vdp.serverSideUserIdExperiments
};

export const clientSideExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments
};

export const serverSideExperiments = {
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const browserCookieIdExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...serverSideBrowserCookieIdExperiments
};

export const userIdExperiments = {
  ...clientSideUserIdExperiments,
  ...serverSideUserIdExperiments
};

export const experiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments,
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const experimentNames = Object.keys(experiments);
